import { Slider, ColorPicker, InputNumber } from 'antd';
import { useSketchProperitesContext } from '../../../../../context/SketchPropertiesContext';
import './SketchConfig.scss';
const PointConfig = () => {
  const { fill, fillOpacity, outline, outlineOpacity, outlineWeight, setState } = useSketchProperitesContext();

  return (
    <>
      {/* <div className="sketch-config__row">
        <span className="sketch-config__label">ICON</span>
        <Select
          className="sketch-config__flex"
          placeholder="Select Icon"
          value={icon}
          onChange={(value) => setState((prev) => ({ ...prev, icon: value }))}
        >
          <Select.Option value="recentIcons">Recently Used Icons</Select.Option>
          <Select.Option value="chooseFromStyles">
            Choose from Styles
          </Select.Option>
          <Select.Option value="upload">Upload</Select.Option>
        </Select>
      </div> */}

      {/* Icon Size */}
      {/* <div className="sketch-config__row">
        <span className="sketch-config__label">ICON SIZE</span>
        <Slider
          className="sketch-config__flex"
          value={iconSize}
          onChange={(value) =>
            setState((prev) => ({ ...prev, iconSize: value }))
          }
        />
        <Input
          className="sketch-config__input"
          value={iconSize}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              iconSize: Number(e.target.value),
            }))
          }
          placeholder="px"
        />
      </div> */}

      {/* Icon Rotation */}
      {/* <div className="sketch-config__row">
        <span className="sketch-config__label">ICON ROTATION</span>
        <Slider
          className="sketch-config__flex"
          value={iconRotation}
          onChange={(value) =>
            setState((prev) => ({ ...prev, iconRotation: value }))
          }
        />
        <Input
          className="sketch-config__input"
          value={iconRotation}
            onChange={(e) =>
              setState((prev) => ({
                ...prev,
                iconRotation: Number(e.target.value),
              }))
            }
          placeholder="°"
        />
      </div> */}

      {/* Fill */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">FILL</span>
        <ColorPicker
          value={fill}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              fill: value.toHexString(),
            }));
            console.log('fill: ', value);
          }}
          showText
        />
      </div>

      {/* Fill Opacity */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">FILL OPACITY</span>
        <Slider className="sketch-config__flex" value={fillOpacity} onChange={(value) => setState((prev) => ({ ...prev, fillOpacity: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={fillOpacity}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              fillOpacity: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="%"
        />
      </div>

      {/* Outline */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">OUTLINE</span>
        <ColorPicker
          value={outline}
          onChange={(value) =>
            setState((prev) => ({
              ...prev,
              outline: value.toHexString(),
            }))
          }
          showText
        />
      </div>

      {/* Outline Opacity */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">OUTLINE OPACITY</span>
        <Slider
          className="sketch-config__flex"
          value={outlineOpacity}
          onChange={(value) => setState((prev) => ({ ...prev, outlineOpacity: value }))}
        />
        <InputNumber
          className="sketch-config__input"
          value={outlineOpacity}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              outlineOpacity: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="%"
        />
      </div>

      {/* Outline Weight */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">OUTLINE WEIGHT</span>
        <Slider className="sketch-config__flex" value={outlineWeight} onChange={(value) => setState((prev) => ({ ...prev, outlineWeight: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={outlineWeight}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              outlineWeight: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="px"
        />
      </div>
    </>
  );
};

export default PointConfig;
